<template>
  <div>
    <v-container>
       <v-row>
        <v-col cols='12' md='4'>
          <inv-basics
            v-if='item'
            :item='item'
            @update='update'
          ></inv-basics>
        </v-col>
        <v-col cols='12' md='4'>
          <inv-details 
            v-if='item'
            :item='item'
            @update='update'
          ></inv-details>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from './Basics'
import Details from './Details'

export default {
  name: 'inventory-item-overview',
  props: {
    item: {
      required: true
    }
  },
  components: {
    'inv-basics': Basics,
    'inv-details': Details
  },
  methods: {
    update (item) {
      this.$emit('update', item)
    },
  }
}
</script>
